import {
  compress,
  decompress,
  trimUndefinedRecursively,
  config,
} from 'compress-json'
import R from 'ramda'

// Lib :   https://www.npmjs.com/package/compress-json

config.sort_key = false
config.error_on_nan = false
config.error_on_infinite = true

export const compressJsonData = jsonObj => {
  const cloneObj = R.clone(jsonObj)
  trimUndefinedRecursively(cloneObj)
  const comData = compress(cloneObj)

  return comData
}

export const decompressJsonData = compressJson => {
  const cloneCompressed = R.clone(compressJson)
  // const cloneCompressed = compressJson

  const parseJson = JSON.parse(cloneCompressed)

  if (R.isEmpty(parseJson)) return {}
  const parseData = decompress(parseJson)

  return parseData
}
